function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M160.911 43.1161C208.401 16.3041 262.111 2.46503 316.644 2.98982L315.448 127.256C282.728 126.941 250.502 135.244 222.009 151.331L160.911 43.1161Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.1058 155.733C73.8268 108.768 113.422 69.9282 160.911 43.1161L222.009 151.331C193.515 167.419 169.758 190.723 153.125 218.902L46.1058 155.733Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.98977 310.665C3.51459 256.132 18.3848 202.698 46.1058 155.733L153.125 218.902C136.493 247.08 127.571 279.141 127.256 311.861L2.98977 310.665Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.116 466.398C16.304 418.908 2.46496 365.198 2.98977 310.665L127.256 311.861C126.941 344.58 135.244 376.807 151.331 405.3L43.116 466.398Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M155.733 581.203C108.768 553.482 69.9281 513.887 43.1161 466.398L151.331 405.3C167.419 433.794 190.723 457.551 218.901 474.184L155.733 581.203Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M310.665 624.319C256.132 623.794 202.698 608.924 155.733 581.203L218.902 474.184C247.08 490.816 279.141 499.738 311.861 500.053L310.665 624.319Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M466.398 584.193C418.908 611.005 365.198 624.844 310.665 624.319L311.861 500.053C344.58 500.368 376.807 492.065 405.3 475.977L466.398 584.193Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M581.203 471.576C553.482 518.541 513.887 557.381 466.398 584.193L405.3 475.977C433.794 459.89 457.551 436.586 474.184 408.407L581.203 471.576Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M624.319 316.644C623.794 371.177 608.924 424.611 581.203 471.576L474.184 408.407C490.816 380.229 499.738 348.168 500.053 315.448L624.319 316.644Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M584.193 160.911C611.005 208.401 624.844 262.111 624.319 316.644L500.053 315.448C500.368 282.728 492.065 250.502 475.977 222.009L584.193 160.911Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M471.576 46.1059C518.541 73.8269 557.381 113.422 584.193 160.911L475.977 222.009C459.89 193.515 436.586 169.758 408.407 153.125L471.576 46.1059Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M316.644 2.98982C371.177 3.51464 424.611 18.3848 471.576 46.1058L408.407 153.125C380.229 136.493 348.168 127.571 315.448 127.256L316.644 2.98982Z"
});

function SvgGroup3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 628,
    height: 628,
    viewBox: "0 0 628 628",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group_3.070117f2.svg";
export { ForwardRef as ReactComponent };